import './src/css/tailwind.css';

import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import React from 'react';

export const wrapRootElement = ({ element }) => (
  <ContentfulLivePreviewProvider locale="en-US" enableLiveUpdates="true">{element}</ContentfulLivePreviewProvider>
);